export let DataSource = {
    path: 'datasource',
    name: 'datasource',
    component: () =>
        import (
            /* webpackChunkName: "data-source" */
            '@/views/back-stage/data-source/data-source-page.vue'
        ),
    children: [{
            path: 'connection',
            name: 'datasource-connection',
            component: () =>
                import (
                    /* webpackChunkName: "data-source-connection" */
                    '@/views/back-stage/data-source/data-source-connection.vue'
                ),
        },
        {
            path: 'source',
            name: 'datasource-source',
            component: () =>
                import (
                    /* webpackChunkName: "data-source-source" */
                    '@/views/back-stage/data-source/data-source-tab.vue'
                ),
        },
        {
            path: 'formsource',
            name: 'form-datasource-source',
            component: () =>
                import (
                    /* webpackChunkName: "data-source-source" */
                    '@/views/back-stage/data-source/form-data-source-tab.vue'
                ),
        },
        {
            path: '*',
            redirect: 'connection',
        },
    ],
};